export const UserStatus = {
  Active: 1,
  InActive: 2,
  Deleted: 3,
};
